module.exports = __webpack_public_path__ + "static/media/UP_ok_zast1.99905b28.svg";